const m = window.require("@ember/engine");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;